import { z } from 'zod'

import type { Equal, ExpectTrue } from '../types/validation'

export type ProductCategory =
  | 'laptops'
  | 'consoles'
  | 'tablets'
  | 'smartwatches'
  | 'smartphones'

export type ProductCategories = Array<{
  id?: string
  technicalName?: string
  name: ProductCategory
}>

export const ProductCategoriesSchema = z.array(
  z.object({
    id: z.string().optional(),
    technicalName: z.string().optional(),
    name: z.enum([
      'laptops',
      'consoles',
      'tablets',
      'smartwatches',
      'smartphones',
    ]),
  }),
)

/* Schemas validation */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type TestProductCategories = ExpectTrue<
  Equal<ProductCategories, z.infer<typeof ProductCategoriesSchema>>
>
